import React, { useCallback, useState } from "react";
import {
  LDS_DOMESTIC_BANK_TRANSFER,
  LDS_INTERNATIONAL_BANK_TRANSFER,
  LDS_BANK_TRANSFER_SUCCESS_SUBTITLE_HE,
  copyBankTransferLine,
  formatDomesticBankTransferText,
  formatInternationalBankTransferText,
} from "../../../utils/ldsBankTransferDetails";
import "./LdsBankTransferDetailsBlock.scss";

function DetailRow({ label, value, dir = "rtl" }) {
  return (
    <div className="lds-bt-details__row" dir={dir}>
      <span className="lds-bt-details__label">{label}</span>
      <span className="lds-bt-details__value">
        <code dir={dir === "ltr" ? "ltr" : undefined}>{value}</code>
      </span>
    </div>
  );
}

function CopyBlockButton({ text }) {
  const [copied, setCopied] = useState(false);
  const onCopy = useCallback(async () => {
    const ok = await copyBankTransferLine(text);
    if (ok) {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    }
  }, [text]);

  return (
    <button type="button" className="lds-bt-details__copy" onClick={onCopy}>
      {copied ? "הועתק" : "העתק הכל"}
    </button>
  );
}

const LdsBankTransferDetailsBlock = ({ className = "" }) => {
  const d = LDS_DOMESTIC_BANK_TRANSFER;
  const i = LDS_INTERNATIONAL_BANK_TRANSFER;
  const domesticText = formatDomesticBankTransferText(d);
  const internationalText = formatInternationalBankTransferText(i);

  return (
    <section
      className={`lds-bt-details ${className}`.trim()}
      aria-label="פרטי העברה בנקאית"
    >
      <div className="lds-bt-details__notice" role="note">
        <p>הזמנה זו שוריינה במערכת.</p>
        <p>זהו סיכום הזמנה לצורך השלמת תשלום בהעברה בנקאית.</p>
        <p>{LDS_BANK_TRANSFER_SUCCESS_SUBTITLE_HE}</p>
      </div>

      <h3 className="lds-bt-details__title">פרטי העברה בנקאית</h3>
      <div className="lds-bt-details__card">
        <div className="lds-bt-details__card-header">
          <p className="lds-bt-details__card-heading">העברות בנקאיות</p>
          <CopyBlockButton text={domesticText} />
        </div>
        <DetailRow label="מוטב" value={d.beneficiaryHe} />
        <DetailRow label="בנק" value={d.bankNameHe} />
        <DetailRow label="חשבון" value={d.accountNumber} />
        <p className="lds-bt-details__hint">{d.footerNoteHe}</p>
      </div>

      <div className="lds-bt-details__card lds-bt-details__card--intl">
        <div className="lds-bt-details__card-header">
          <p className="lds-bt-details__card-heading">העברת זה&quot;ב / העברה מחו&quot;ל</p>
          <CopyBlockButton text={internationalText} />
        </div>
        <DetailRow label="Bank name" value={i.bankNameEn} dir="ltr" />
        <DetailRow label="Bank number" value={i.bankNumber} dir="ltr" />
        <DetailRow label="Branch number" value={i.branchNumber} dir="ltr" />
        <DetailRow label="SWIFT / BIC" value={i.swiftBic} dir="ltr" />
        <DetailRow label="IBAN" value={i.iban} dir="ltr" />
        <DetailRow label="Currency" value={i.currencyEn} dir="ltr" />
        <DetailRow label="Beneficiary" value={i.beneficiaryEn} dir="ltr" />
      </div>
    </section>
  );
};

export default LdsBankTransferDetailsBlock;
